import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Activation } from 'src/app/interfaces/activation.interface';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-sign-in-page',
  templateUrl: './activation-page.component.html',
  styleUrls: ['./activation-page.component.scss']
})
export class ActivationPageComponent implements OnInit {
  public type: 'ACTIVATION' | 'LOST_PW' | 'NEW_EMAIL';
  public key: string;
  public status: 'ENTER_KEY' | 'VALIDATING' | 'ENTER_PWD';
  public activation: Activation;
  public password: string;
  public passwordValidation: string;
  public keyInvalid = false;
  public pwdMatch = true;

  public passwordFormControl: FormControl;

  public passwordValidationFormControl: FormControl;

  public keyFormControl: FormControl;
  public keyFormSubscription: Subscription;
  public hidePW = true;
  public hidePWconfirm = true;




  constructor(private app: AppService, private route: ActivatedRoute) {

    this.key = this.route.snapshot.paramMap.get('key');

    switch (this.route.snapshot.url[0].path) {
      case 'aktivierung':
        this.type = 'ACTIVATION';
        break;
      case 'neues-passwort':
        this.type = 'LOST_PW';
        break;
      case 'email-validierung':
        this.type = 'NEW_EMAIL';
        break;
      default:
        this.app.router.navigateByUrl('');
        break;
    }

    if (this.key) {
      this.checkActivation();
    } else {
      this.status = 'ENTER_KEY';
    }
  }

  onFocusOut(): void {
    this.passwordFormControl.setValidators([
      Validators.required,
      Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$+.()\/\\#;:_\-=!%*?&])[A-Za-z\d@$+.()\/\\#;:=_\-!%*?&]{8,}$/gm)
    ]);
    // this.passwordFormControl.updateValueAndValidity();
  }

  onFocus(): void {

    this.passwordFormControl.setValidators([
      Validators.required
    ]);
  }

  ngOnInit(): void {
    this.keyFormControl = new FormControl(this.key, [
      Validators.required,
      (c: AbstractControl) => {
        if (!this.keyInvalid) {
          return null;
        } else {
          return {
            key_valid: {
              valid: false
            }
          };
        }
      }
    ]);


    this.passwordFormControl = new FormControl(this.password, [
      Validators.required
    ]);



    this.passwordValidationFormControl = new FormControl(this.passwordValidation, [
      Validators.required,
      (c: AbstractControl) => {
        if (this.passwordValidation === this.password) {
          return null;
        } else {
          return {
            pwd_validated: {
              valid: false
            }
          };
        }
      }
    ]);

  }

  public onSubmit(): void {
    switch (this.status) {
      case 'ENTER_KEY':
        this.key = this.keyFormControl.value;
        this.keyFormControl.updateValueAndValidity();
        if (!this.keyFormControl.errors) {
          this.checkActivation();
        }
        break;
      case 'ENTER_PWD':
        this.passwordValidationFormControl.updateValueAndValidity();
        this.passwordFormControl.updateValueAndValidity();
        this.password = this.passwordFormControl.value;
        this.passwordValidation = this.passwordValidationFormControl.value;
        if (!this.passwordFormControl.errors && !this.passwordFormControl.errors) {
          switch (this.type) {
            case 'ACTIVATION':
              this.activate();
              break;
            case 'LOST_PW':
              this.updatePassword();
              break;
          }
        }
        break;
    }
  }

  protected injectInvalidKey(): void {
    setTimeout(() => {
      this.app.dialog.closeLoader();
      this.keyInvalid = true;
      this.status = 'ENTER_KEY';
      this.keyFormControl.markAllAsTouched();
      this.keyFormControl.markAsDirty();
      this.keyFormControl.updateValueAndValidity();
      this.keyFormSubscription = this.keyFormControl.valueChanges.subscribe(() => {
        this.keyInvalid = false;
        this.keyFormControl.markAsPristine();
        this.keyFormSubscription.unsubscribe();
      });
    }, 1000);
  }

  protected async activate(): Promise<void> {
    this.app.activate({
      key: this.key,
      password: this.password
    }).then((status: boolean) => {
      if (status) {
        this.success();
      }
    }).catch((e: Error) => {
      console.error(e);
      this.app.toast.open('Unbekannter Fehler', null, {
        panelClass: 'warn'
      });
      this.app.dialog.closeLoader();
    });
  }

  protected async updatePassword(): Promise<void> {
    this.app.dialog.loader({
      title: 'Aktualisiere E-Mail-Adresse'
    });
    this.app.updatePassword({
      key: this.key,
      password: this.password
    }).then((status: boolean) => {
      if (status) {
        this.success();
      }
    }).catch((e: Error) => {
      console.error(e);
      this.app.toast.open('Unbekannter Fehler', null, {
        panelClass: 'warn'
      });
      this.app.dialog.closeLoader();
    });
  }

  protected async updateEmail(): Promise<void> {
    this.app.isAuthed((auth) => {
      if (auth) {
        this.app.dialog.loader({
          title: 'Validiere E-Mail-Adresse'
        });
        this.app.updateEmail({
          key: this.key
        }).then((email: string) => {
          if (email) {
            this.app.user.email = email;
            this.success();
          }
        }).catch((e: Error) => {
          console.error(e);
          this.app.dialog.closeLoader();
          this.app.toast.open('Unbekannter Fehler', null, {
            panelClass: 'warn'
          });
        });
      } else {
        this.app.dialog.closeLoader();
        this.app.router.navigateByUrl('', {
          params: {
            redirectTo: 'email-validierung/' + this.key
          }
        });
      }
    });
  }

  protected success(): void {
    this.app.dialog.closeLoader();
    this.app.router.navigateByUrl(this.route.snapshot.url[0].path + '/erfolgreich', {
      params: {
        type: this.type
      }
    });
  }

  protected async checkActivation(): Promise<void> {
    let loaderTitle;
    switch (this.type) {
      case 'ACTIVATION':
        loaderTitle = 'Überprüfe Aktivierungs-Code';
        break;
      case 'LOST_PW':
        loaderTitle = 'Überprüfe Freigabe-Code';
        break;
      case 'NEW_EMAIL':
        loaderTitle = 'Überprüfe Validierungs-Code';
        break;
    }

    this.app.dialog.loader({
      title: loaderTitle
    });

    this.app.checkActivationKey(this.key).then((activation) => {
      activation.expires = new Date(activation.expires);
      console.log(activation, this.type);
      if (
        activation
        && !activation.used
        && activation.type === this.type
        && (activation.expires >= (new Date()))
      ) {
        this.activation = activation;
        if (this.activation.type === 'NEW_EMAIL') {
          this.updateEmail();
        } else {
          setTimeout(() => {
            this.app.dialog.closeLoader();
            this.status = 'ENTER_PWD';
          }, 1000);
        }

      } else {
        this.injectInvalidKey();
      }
    }).catch((e: Error) => {
      this.injectInvalidKey();
    });
  }
}
